
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component<OrderItemsListItem>({})
export default class OrderItemsListItem extends Vue {
	@Prop({ type: Object, required: true }) item!: OrderItem;
	@Prop({ type: Object, required: true }) itemParent!: ItemParent;
}
